import React, { FC } from 'react'
import s from './DocumentsSection.module.scss'
import { BACKEND_URL } from '../../../api'
import { IProductDocument } from '../../../store/types'
import { FaFileDownload } from 'react-icons/fa'

interface DocumentsSectionProps {
    documents?: IProductDocument[]
    pricingInfo?: string
}

const DocumentsSection: FC<DocumentsSectionProps> = ({ documents, pricingInfo }) => {
    if ((!documents || documents.length === 0) && !pricingInfo) return null

    return (
        <section className={s.documents}>
            <div className='container'>
                {/* Документация */}
                {documents && documents.length > 0 && (
                    <div className={s.docsBlock}>
                        <h2 className='title'><span />Документация</h2>
                        <div className={s.documentsList}>
                            {documents.map((doc) => (
                                <a 
                                    key={doc.id} 
                                    href={BACKEND_URL + doc.file_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={s.documentCard}
                                >
                                    <div className={s.documentIcon}>
                                        {React.createElement(FaFileDownload as any)}
                                    </div>
                                    <div className={s.documentInfo}>
                                        <h3>{doc.title}</h3>
                                        {doc.file_size && <span>{doc.file_size}</span>}
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                )}

                {/* Информация о стоимости */}
                {pricingInfo && (
                    <div className={s.pricingBlock}>
                        <h2 className='title'><span />Информация о стоимости</h2>
                        <p className={s.pricingDescription}>{pricingInfo}</p>
                    </div>
                )}
            </div>
            <div className={`${s.shapeRight}`} />
            <span className={`${s.gradientLine} lineGradient bottom-line`} />
        </section>
    )
}

export default DocumentsSection

